import { SerpApStockTransferSnapshot } from '@/components/Approval/@components/SerpApStockTransfer';
import { parseSerpContent } from '@/utils/approval/serpDocument';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 170 SERP AP 재고 이관 요청 — 저장 content 그대로(레거시 조회와 동일) */
const SerpApStockTransferSlot = ({ data }: ContentExtraProps) => {
  const content = parseSerpContent(data.attributes);
  if (!content) return null;
  return (
    <ContentSlotRoot>
      <SerpApStockTransferSnapshot content={content} />
    </ContentSlotRoot>
  );
};

export default SerpApStockTransferSlot;
